import React from 'react';
import { DATE_MED, moment } from '../../../shared/i18n/date-time/moment';
import { formatBookingTimePreservingSelection } from './helpers/formatBookingTimePreservingSelection';

interface IFormattedBookingDateProps {
	date: string | Date;
	selectedTime?: string;
}

export const BookingDate = ({
	date,
	selectedTime,
}: IFormattedBookingDateProps) => (
	<>
		{moment(date).format(DATE_MED)}
		{' - '}
		{formatBookingTimePreservingSelection(new Date(date), selectedTime)}
	</>
);
